export const LIMITED_NO_APPLICATION = 'no-application'
export const LIMITED_BLURRED_CARDS = 'blurred-cards'
export const LIMITED_CONTROL = 'control'
export const CREDIBILITY_BANNER = 'credibility-banner'
export const NO_CREDIBILITY_BANNER = 'no-credibility-banner'
export const FREEMIUM_PRO_MODAL_VIDEO = 'pro-modal-video'
export const FREEMIUM_STATUS_ENABLED = 'enabled'
export const SIMILAR_CARD_BLURRED = 'blurred'
export const FREEMIUM_EXIT_POPUP_REGULAR = 'paywall-offer-regular'
export const FREEMIUM_EXIT_POPUP_SPECIAL = 'paywall-offer-special'
export const ACTIVATION_POPUP_PAID_CONTROL = 'control'
export const ACTIVATION_POPUP_PAID_TEST = 'test'
export const PAYMENT_POPUP_CONTROL = 'control'
export const PAYMENT_POPUP_ON = 'on'
export const WINNERS_BTN_CONTROL = 'control'
export const WINNERS_BTN_VISIBLE = 'visible'
export const FIELD_OF_STUDY_SCHOOL_LEVEL_GENDER = 'FieldOfStudy-SchoolLevel-Gender'
export const NEWS_TICKER_TEST = 'test'
export const NEWS_TICKER_CONTROL = 'control'
export const WINNER_BLAST_TEST = 'test'
export const WINNER_BLAST_CONTROL = 'control'
export const AI_ESSAY_EDITOR_CONTROL = 'control'
export const REFERRAL_PROGRAM_CONTROL = 'control'
export const REFERRAL_PROGRAM_ON = 'on'
export const LOOP_GUEST_ACCOUNT_CONTROL = 'control'
export const LOOP_GUEST_ACCOUNT_ON = 'on'
export const LOOP_TRIAL_EXTENSION_CONTROL = 'control'
export const LOOP_TRIAL_EXTENSION_ON = 'on'
